"use strict";

window.FoG = window.FoG || {};

window.FoG.InviteForm = (function($) {
  function init() {
    $(() => {
      $('form.section-membershipCta__form').on('submit', function(e) {
        e.preventDefault();

        var $form = $(this);
        var $emailInput = $form.find('input[type=email]');
        var emailAddr = $emailInput.val();

        var fnSuccess = () => {
          FoG.Modal.message($('<span></span>').html('<b>Thank you for referring a friend to Future of Good.</b>'));
          $emailInput.val('');
        };
        
        NA.Ajax.postForm($form, 'inviteAFriend', fnSuccess, FoG.Modal.errorFromAjaxResponse);
      });
    });
  }
  
  init();
})(jQuery);
